export default class SlotDomainService {
    static fromJSON({ slots, staff, offices, modalities, }) {
        return slots.map((slot) => (Object.assign(Object.assign({}, slot), { staff: staff.filter((s) => slot.staffOfficeModalities
                .map((som) => som[0])
                .includes(s.personId)), offices: offices.filter((o) => slot.staffOfficeModalities
                .map((som) => som[1])
                .includes(o.id)), modalities: modalities.filter((m) => slot.staffOfficeModalities
                .map((som) => som[2])
                .includes(m.id)), from: new Date(slot.from), to: new Date(slot.to) })));
    }
    static doesSlotHaveOptions(slot) {
        return slot.staffOfficeModalities.length > 1;
    }
}
